import {
  ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS,
  ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED,
  RESET_ADDUPDATENOTIFICATIONCONFIGADMIN,
  LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN,
  NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADDUPDATENOTIFICATIONCONFIGADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
